import { useTranslation } from '@/hooks/useTranslation'

export function ArtifactPreviewSkeleton({
	embedParentAnnouncesLoading = false,
}: {
	embedParentAnnouncesLoading?: boolean
}) {
	const { t } = useTranslation()
	return (
		<div
			className="space-y-4 p-4"
			aria-busy={embedParentAnnouncesLoading ? undefined : true}
			role={embedParentAnnouncesLoading ? undefined : 'status'}
			aria-hidden={embedParentAnnouncesLoading ? true : undefined}
		>
			{!embedParentAnnouncesLoading && <span className="sr-only">{t('common.loading')}</span>}
			<div className="space-y-2">
				<div className="h-4 w-20 rounded bg-muted animate-pulse" />
				<div className="h-6 w-32 rounded bg-muted animate-pulse" />
			</div>
			<div className="space-y-2">
				<div className="h-3 w-16 rounded bg-muted animate-pulse" />
				<div className="h-4 w-full max-w-[200px] rounded bg-muted animate-pulse" />
			</div>
			<div className="space-y-2">
				<div className="h-3 w-12 rounded bg-muted animate-pulse" />
				<div className="h-4 w-full max-w-[180px] rounded bg-muted animate-pulse" />
			</div>
			<div className="space-y-2">
				<div className="h-3 w-14 rounded bg-muted animate-pulse" />
				<div className="h-4 w-24 rounded bg-muted animate-pulse" />
			</div>
			<div className="pt-2">
				<div className="h-9 w-full rounded bg-muted animate-pulse" />
			</div>
		</div>
	)
}
